import config from '@config';
import { links } from '@app/router';

export const processImageTags = (content: string) =>
    content.replace(imageSrcRegex, `src="${config.app.staticPages.imagesHost}/`);

export const processAnchorTags = (content: string) =>
    content.replace(hrefRegex, (expression, url) => {
        if (isDocument(url)) {
            return createDocumentRoute(url);
        }
        return createPageRoute(url);
    });

export const appendIdAttributeAfterNameAttribute = (content: string) =>
    content.replace(nameRegex, (expression, name) => {
        return `${expression} ${createIdAttribute(name)}`;
    });
/**
 * We can't catch any external link because of imageSrcRegex and hrefRegex
 * require that link starts with '/'
 */
const imageSrcRegex = /src="\//gim;
const hrefRegex = /href="\/([a-zA-Z0-9_#;&\?\/\/.\-]+)"/gim;
const nameRegex = /name="([a-zA-Z0-9_#\?\/\/.\-]+)"/gim;

const isDocument = (url: string) => url.includes('documents');
const createDocumentRoute = (url: string) => `href="${config.app.staticPages.documentsHost}/${url}"`;
const createPageRoute = (url: string) => `href="${links.wiki}/${url}"`;
const createIdAttribute = (name: string) => `id="${name}"`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/wiki/_private/HTMLUtil.ts